import { default as _makeInternalLink } from "features/common/paging/components/PathEndsWithModalJourneyWrapper/makeInternalLink";
import makeGetBaseLink from "features/common/routing/ends-with-routes/makeGetBaseLink";

import {
  makePasswordResetPath,
  makePasswordResetSignInPath,
  makeSignInPath,
  makeSignUpAccountTypePath,
  makeSignUpConfirmPassword,
  makeSignUpPath,
  makeSignUpStudentDetailsPath,
  makeSignUpTeacherDetailsPath,
  makeSignUpUserDetailsPath
} from "./links/paths";

export const pathEndings = {
  signUp: makeSignUpPath(""),
  signIn: makeSignInPath(""),
  resetPassword: makePasswordResetPath(""),
  resetPasswordSignIn: makePasswordResetSignInPath(""),
  userDetails: makeSignUpUserDetailsPath(""),
  accountType: makeSignUpAccountTypePath(""),
  studentDetails: makeSignUpStudentDetailsPath(""),
  teacherDetails: makeSignUpTeacherDetailsPath(""),
  confirmPassword: makeSignUpConfirmPassword("")
};

export const openForPathsEndingWith: string[] = Object.values(pathEndings);

export const makeInternalLink = _makeInternalLink(openForPathsEndingWith);
export const getBaseLink = makeGetBaseLink(openForPathsEndingWith);
